<template>
    <LayoutPage>
        <template v-slot:banner>
            <BannerSmallerWithSearchAndButton
                :imageName="$t('UI.banners.smallerBannerImage')"
                :title="'Workshopy'"
                :description="'Prihláste sa na niektorý z pripravovaných workshopov, alebo využite možnosť vytvorenia workshopu na mieru.'"
            />
        </template>
        <template v-slot:content>
            <div class="box box--space-vertical">
                <div class="mm-section">
                    <div class="mm-section-content">
                        <div class="container-fluid w-100">

                            <div class="box box--space-vertical">
                                <router-link :to="localeRoute('workshops')"
                                    class="mm-link mm-link--icon-left-space-s">
                                    <i class="icon icon-arrow-left"></i>späť na zoznam workshopov
                                </router-link>
                            </div>

                            <div v-if="data">
                                <div class="row">
                                    <div class="col-md-5 box box--space-bottom">
                                        <div class="box box--grey box--space-inside">
                                            <h2 class="headline headline--fourth headline headline--uppercase mt-4">
                                                {{data.title}}
                                            </h2>
                                            <div v-if="data.previewData">
                                                <ul class="list list--transparent-background">
                                                    <li
                                                        v-for="item in workshopPropFeatures"
                                                        :key="item.id"
                                                        class="list__item">
                                                        <div class="item__row__wrapper">
                                                            <div class="item__left-content item__left-content--icon-no-margin item__left-content--align-top">
                                                                <span>
                                                                    <i :class="`icon-2x icon ${item.icon}`"></i>
                                                                </span>
                                                            </div>
                                                            <div class="item__content item__content--condensed">
                                                                <div class="item__text--label">
                                                                    {{item.name}}
                                                                </div>
                                                                <div class="text--bigger-paragraph">
                                                                    {{item.value}}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div class="row box box--grey box--space-inside">
                                            <div v-if="submitStatus !== 'SUCCESS'"
                                                class="col">
                                                <h3 class="headline headline--fifth">
                                                    Prihlásenie na workshop
                                                </h3>

                                                <form
                                                    @submit.prevent="onSubmit">
                                                    <div class="row">
                                                        <div class="col">
                                                            <Field
                                                                :trimModel="true"
                                                                :fieldModel="$v.name"
                                                                :field="nameField">
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">
                                                            <Field
                                                                :trimModel="true"
                                                                :fieldModel="$v.surname"
                                                                :field="surnameField">
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">
                                                            <Field
                                                                :trimModel="true"
                                                                :fieldModel="$v.email"
                                                                :field="emailField">
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">
                                                            <Field
                                                                :trimModel="true"
                                                                :fieldModel="$v.telephone"
                                                                :field="telephoneField">
                                                            </Field>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">
                                                            <TextAreaField
                                                                className="materialize-textarea--xl"
                                                                :fieldModel="$v.comment"
                                                                :field="commentField">
                                                            </TextAreaField>
                                                        </div>
                                                    </div>

                                                    <p v-if="submitStatus === 'ERROR'"
                                                        class="text text--error">
                                                        Doslo k chybe. Zkontrolujte prosim formular a odeslete ho znovu
                                                    </p>


                                                    <button
                                                        v-if="submitStatus === 'REQUEST'"
                                                        disabled
                                                        class="button button--wider-border transparent--button button--l button--uppercase">
                                                        Odesilani
                                                    </button>
                                                    <button
                                                        v-else
                                                        class="button button--wider-border transparent--button button--l button--uppercase">
                                                        Odeslat
                                                    </button>

                                                </form>
                                            </div>

                                            <div v-if="submitStatus === 'SUCCESS'"
                                                class="col box--center">
                                                <div>
                                                    <div class="box box--spaces">
                                                        <span class="icon icon-eye icon-4x"></span>
                                                    </div>
                                                    <h3 class="headline headline--third headline--uppercase">
                                                        ďakujeme
                                                    </h3>
                                                </div>
                                                <br>
                                                <h3 class="headline headline--fifth">
                                                    Vaša správa bola úspešne odoslaná!
                                                </h3>
                                                <h3 class="headline headline--fifth">
                                                    Budeme Vás kontaktovať.
                                                </h3>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-md-7">
                                        <div class="box ">
                                            <div v-if="data.content">
                                                <img v-if="image_preview" :src="image_preview" alt="" style="width: 100%">
                                                <div class="box box--space-vertical text--bigger-paragraph" v-html="data.content"></div>
                                            </div>
                                            <div v-else>This page does not have content</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </LayoutPage>
</template>

<script>
import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import webCMS from '@/services/WebCMS';
import Field from '@/components/ui/Field';
import TextAreaField from '@/components/ui/TextAreaField';
import LayoutPage from '@/components/layouts/Page';
import BannerSmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';
import { registerToWorkshop } from '@/services/MapsfyApi';


import {
    getFields,
    validations
} from './forms';

export default {
    components: {
        Field,
        TextAreaField,
        BannerSmallerWithSearchAndButton,
        LayoutPage
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
        this.loadData();
    },
    data() {
        const $t = this.$t.bind(this);
        return {
            data: null,
            submitStatus: null,
            name: "",
            surname: "",
            telephone: "",
            email: "",
            comment: "",
            emailId: this.formId + '-inputEmail',
            ...getFields($t)
        };
    },
    validations: {
        ...validations
    },
    watch: {
        '$route.params.id': function () {
            this.data = null;
            this.loadData();
        }
    },
    methods: {
        onSubmit() {
            this.submitStatus = null;
            this.submitStatus = 'REQUEST';
            this.$v.$touch();
            if (this.$v.$invalid) {
                this.submitStatus = 'ERROR';
            }

            if (!this.$v.$invalid) {
                 const prop = {
                    workshop: this.pageId,
                    name: this.name,
                    surname: this.surname,
                    email: this.email,
                    phone: this.telephone,
                    message: this.comment
                };

                registerToWorkshop(prop)
                    .then(() => {
                        this.submitStatus = 'SUCCESS';
                    })
                    .fail(e => {
                        console.log('ERROR: ', e);
                        this.submitStatus = 'ERROR';
                    });
            }
        },
        loadData() {
            webCMS.getPageBySeoId(this.axios, {seoId: this.pageId})
                .then(res => {
                    this.data = res;
                });
        }
    },
    computed: {
        workshopPropFeatures() {
            if (this.data) {
                return [
                    ...(this.data.previewData.date ? [{id: 'feature-1', icon: 'icon-calendar', name: 'Kedy', value: this.data.previewData.date}] : []),
                    ...(this.data.previewData.address ? [{id: 'feature-2', icon: 'icon-map', name: 'Kde', value: this.data.previewData.address}] : []),
                    ...(this.data.previewData.targetAudience ? [{id: 'feature-3', icon: 'icon-user', name: 'Komu', value: this.data.previewData.targetAudience}] : []),
                    ...(this.data.previewData.time ? [{id: 'feature-4', icon: 'icon-tag', name: 'Začiatok workshopu', value: this.data.previewData.time}] : []),
                    ...(this.data.previewData.duration ? [{id: 'feature-5', icon: 'icon-menu-2', name: 'Doba trvania', value: this.data.previewData.duration}] : []),
                    ...(this.data.previewData.participants ? [{id: 'feature-6', icon: 'icon-users', name: 'Počet účastníkov', value: this.data.previewData.participants}] : []),
                    ...(this.data.previewData.price ? [{id: 'feature-7', icon: 'icon-payment', name: 'Cena', value: this.data.previewData.price}] : []),
                ];
            }
            return null;
        },
        pageId() {
            return this.$route.params.id;
        },
        image_preview() {
            if (this.data && this.data.attachments) {
                var image = this.data.attachments.find(item => item.type === "preview-image");
                if (image) {
                    return `https://mm_cms.emis-online.sk/cms/web_cms_apigateway/api/Pages/pages/attachment/${image.attachmentKey}`;
                }
            }
            return null;
        }

    }
}
</script>


<style lang="scss" scoped>
</style>
